import { gql } from "@apollo/client";

export const UpdateInstalledBaseNodeFile = gql`
    mutation UpdateInstalledBaseNodeFile ($installedBaseNodeFileId: ID!, $input: InstalledBaseNodeFileUpdateAttributesInput!){
        updateInstalledBaseNodeFile (installedBaseNodeFileId: $installedBaseNodeFileId, input: $input) {
            id
            filename
            comment
        }
    }
`;
